/**
 * @generated SignedSource<<9f5afe454f85d74db36f90379dbdb67e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InquireAndSave_userProfile$data = {
  readonly analyticsId: number;
  readonly avatarImage: {
    readonly id: string;
    readonly uid: string;
    readonly url: string;
  } | null;
  readonly canReceiveInquiries: boolean;
  readonly contact: {
    readonly id: string;
  } | null;
  readonly displayUsername: string;
  readonly firstName: string | null;
  readonly hasCompletedIndyOnboarding: boolean;
  readonly id: string;
  readonly isSavedContact: boolean;
  readonly lastName: string | null;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"DiscoverUnauthenticatedInquiryModal_profile" | "WorkWithMe_userProfile">;
  readonly " $fragmentType": "InquireAndSave_userProfile";
};
export type InquireAndSave_userProfile$key = {
  readonly " $data"?: InquireAndSave_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"InquireAndSave_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InquireAndSave_userProfile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canReceiveInquiries",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Contact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContraImage",
      "kind": "LinkedField",
      "name": "avatarImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uid",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSavedContact",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCompletedIndyOnboarding",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkWithMe_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiscoverUnauthenticatedInquiryModal_profile"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "8dc57220bf4e861b6108ac3103ae20e9";

export default node;
